import { NgModule } from '@angular/core'
import { StoreModule } from '@ngrx/store'
import { StoreKeysEnum } from '../../store/store-keys'
import { authReducer } from './state/auth.reducers'

@NgModule({
    imports: [
        StoreModule.forFeature(StoreKeysEnum.CommonAuth, authReducer)
    ]
})
export class AuthModule {}